import { useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { SortingState } from '@tanstack/react-table';
import {
  useAuthUserRestaurant,
  useGetRestaurantContactFormSubmissionsQuery,
} from '@durma-soft/gros-sdk';

import TableSizeSyncProvider from '@/providers/TableSizeSyncProvider';

import { DataTable } from '@/components/shared/data-table';

import { columns } from '@/config/restaurant/meetings';

const RestaurantMeetings = () => {
  const { t } = useTranslation();
  const memoizedColumns = useMemo(() => {
    return columns(t);
  }, [t]);

  const restaurant = useAuthUserRestaurant();

  const { data, isLoading } = useGetRestaurantContactFormSubmissionsQuery(
    restaurant.id,
  );

  const [restaurantSorting, setRestaurantSorting] = useState<SortingState>([]);
  const [companySorting, setCompanySorting] = useState<SortingState>([]);

  return (
    <>
      <Helmet>
        <title>{t('meetings.title')}</title>
      </Helmet>
      <div>
        <div className="flex items-center">
          <h1 className="text-lg font-semibold md:text-2xl">
            {t('meetings.title')}
          </h1>
        </div>
        <TableSizeSyncProvider>
          <div className="mt-5 flex flex-col gap-5">
            <div className="flex-1 flex flex-col gap-1">
              <h3 className="text-xl font-medium">
                {t('meetings.restaurants')}
              </h3>
              <DataTable
                isSyncReference={true}
                columns={memoizedColumns}
                data={data?.restaurants || []}
                isLoading={isLoading}
                sorting={restaurantSorting}
                setSorting={setRestaurantSorting}
              />
            </div>
            <div>
              <div className="flex flex-col gap-1">
                <h3 className="text-xl font-medium">
                  {t('meetings.companies')}
                </h3>
                <DataTable
                  columns={memoizedColumns}
                  data={data?.companies || []}
                  isLoading={isLoading}
                  sorting={companySorting}
                  setSorting={setCompanySorting}
                />
              </div>
            </div>
          </div>
        </TableSizeSyncProvider>
      </div>
    </>
  );
};

export default RestaurantMeetings;
